import POSConfigModule from "@/store/modules/pos-config";
import { computed } from "vue";

// X: Prod (FBA and FlipLab)
const ADDONS_DISABLED_GROUP_IDS = [
  19547, 19578, 19581, 19582, 19583, 19584, 19585, 19586, 19589, 19319, 19543,
  19544, 19545, 19546, 19587, 19469,
];

// we disabled addons logic for some groups
export const hasAddonsEnabled = computed(() => {
  const groupId = POSConfigModule.groupId;
  return !groupId || !ADDONS_DISABLED_GROUP_IDS.includes(groupId);
});
